export default {
  ar() {
    return {
      addCreditCard: 'اضافة بطاقة ائتمانية',
      canceled: 'Payment Term Canceled',
      charged_on: '%{date} تم استقبال الدفع',
      due: 'حتي تاريخ %{date}',
      due_soon: 'سوف يتم الدفع فى خلال 24 ساعة',
      due_passed: 'Due date has passed',
      due_with_card: 'Will be charged on %{date} with card ending in %{last4}',
      error_saving: 'There was an error saving your card',
      pay_amount: 'Pay %{amount}',
      pay_now: 'Pay Now',
      payment_number: 'Payment %{number}:',
      payment_terms: 'بنود الدفع',
      please_call: 'من فضلك قم بالتواصل مع %{link} اذا كان لديك اي شكاوى',
      processing_amount: 'Processing %{amount}',
      refund: 'A refund of %{amount} was processed of on %{date}',
      select_terms: 'Select Payment Term(s) to Update'
    }
  },

  de() {
    return {
      addCreditCard: 'Kreditkarte hinzufügen',
      canceled: 'Payment Term Canceled',
      charged_on: 'Zahlung erfasst %{date}',
      due: 'Fällig am %{date}',
      due_passed: 'Due date has passed',
      due_soon: 'Diese Zahlung wird in den nächsten 24 Stunden verarbeitet',
      due_with_card: 'Will be charged on %{date} with card ending in %{last4}',
      error_saving: 'There was an error saving your card',
      pay_amount: 'Pay %{amount}',
      pay_now: 'Pay Now',
      payment_number: 'Payment %{number}:',
      payment_terms: 'Zahlungsfristen',
      please_call: 'Bitte rufen Sie uns unter der Rufnummer %{link} an, falls irgendwelche Probleme auftreten.',
      processing_amount: 'Processing %{amount}',
      refund: 'A refund of %{amount} was processed of on %{date}',
      select_terms: 'Select Payment Term(s) to Update'
    }
  },

  en() {
    return {
      addCreditCard: 'Add Credit Card',
      canceled: 'Payment Term Canceled',
      charged_on: 'Charged on %{date}',
      due: 'Due on %{date}',
      due_passed: 'Due date has passed',
      due_soon: 'This payment will be charged within 24 hours',
      due_with_card: 'Will be charged on %{date} with card ending in %{last4}',
      error_saving: 'There was an error saving your card',
      pay_amount: 'Pay %{amount}',
      pay_now: 'Pay Now',
      payment_number: 'Payment %{number}:',
      payment_terms: 'Payment Terms',
      please_call: 'Please call %{link} if you have any issues.',
      processing_amount: 'Processing %{amount}',
      refund: 'A refund of %{amount} was processed of on %{date}',
      select_terms: 'Select Payment Term(s) to Update'
    }
  },

  enGB() {
    return {
      addCreditCard: 'Add Credit Card',
      canceled: 'Payment Term Canceled',
      charged_on: 'Charged on %{date}',
      due: 'Due on %{date}',
      due_passed: 'Due date has passed',
      due_soon: 'This payment will be charged within 24 hours',
      due_with_card: 'Will be charged on %{date} with card ending in %{last4}',
      error_saving: 'There was an error saving your card',
      pay_amount: 'Pay %{amount}',
      pay_now: 'Pay Now',
      payment_number: 'Payment %{number}:',
      payment_terms: 'Payment Terms',
      please_call: 'Please call %{link} if you have any issues.',
      processing_amount: 'Processing %{amount}',
      refund: 'A refund of %{amount} was processed of on %{date}',
      select_terms: 'Select Payment Term(s) to Update'
    }
  },

  esMX() {
    return {
      addCreditCard: 'Añadir Tarjeta de Crédito',
      canceled: 'Payment Term Canceled',
      charged_on: 'Pago Capturado %{date}',
      due: 'a pagar %{date}',
      due_passed: 'Due date has passed',
      due_soon: 'Este pago será cargado dentro de las próximas 24 horas',
      due_with_card: 'Will be charged on %{date} with card ending in %{last4}',
      error_saving: 'There was an error saving your card',
      pay_amount: 'Pay %{amount}',
      pay_now: 'Pay Now',
      payment_number: 'Payment %{number}:',
      payment_terms: 'Plazos de Pago',
      please_call: 'Favor de llamar al %{link} si tiene cualquier tipo de problema',
      processing_amount: 'Processing %{amount}',
      refund: 'A refund of %{amount} was processed of on %{date}',
      select_terms: 'Select Payment Term(s) to Update'
    }
  },

  fr() {
    return {
      addCreditCard: 'Ajouter la carte de crédit',
      canceled: 'Payment Term Canceled',
      charged_on: 'Paiement Capturé %{date}',
      due: 'dû le %{date}',
      due_passed: 'Due date has passed',
      due_soon: 'Ce paiement sera facturé dans les 24 heures.',
      due_with_card: 'Will be charged on %{date} with card ending in %{last4}',
      error_saving: 'There was an error saving your card',
      pay_amount: 'Pay %{amount}',
      pay_now: 'Pay Now',
      payment_number: 'Payment %{number}:',
      payment_terms: 'Modalités de paiement',
      please_call: 'Veuillez appeler %{link} si vous avez des questions.',
      processing_amount: 'Processing %{amount}',
      refund: 'A refund of %{amount} was processed of on %{date}',
      select_terms: 'Select Payment Term(s) to Update'
    }
  },

  it() {
    return {
      addCreditCard: 'Aggiungi carta di credito',
      canceled: 'Payment Term Canceled',
      charged_on: 'Addebito effettuato %{date}',
      due: 'scadenza %{date}',
      due_passed: 'Due date has passed',
      due_soon: 'Questo pagamento verrà addebitato entro 24 ore',
      due_with_card: 'Will be charged on %{date} with card ending in %{last4}',
      error_saving: 'There was an error saving your card',
      pay_amount: 'Pay %{amount}',
      pay_now: 'Pay Now',
      payment_number: 'Payment %{number}:',
      payment_terms: 'Modalità di pagamento',
      please_call: 'Per qualsiasi problema, ti preghiamo di contattare il numero %{link}.',
      processing_amount: 'Processing %{amount}',
      refund: 'A refund of %{amount} was processed of on %{date}',
      select_terms: 'Select Payment Term(s) to Update'
    }
  },

  ja() {
    return {
      addCreditCard: 'クレジットカード情報を追加',
      canceled: 'Payment Term Canceled',
      charged_on: '支払が認証されました %{date}',
      due: '支払い期日 %{date}',
      due_passed: 'Due date has passed',
      due_soon: 'ご請求額は24時間以内に課金されます。',
      due_with_card: 'Will be charged on %{date} with card ending in %{last4}',
      error_saving: 'There was an error saving your card',
      pay_amount: 'Pay %{amount}',
      pay_now: 'Pay Now',
      payment_number: 'Payment %{number}:',
      payment_terms: 'お支払い期間',
      please_call: '問題が発生した場合には %{link} までお電話ください。',
      processing_amount: 'Processing %{amount}',
      refund: 'A refund of %{amount} was processed of on %{date}',
      select_terms: 'Select Payment Term(s) to Update'
    }
  },

  pl() {
    return {
      addCreditCard: 'dodaj kartę kredytową',
      canceled: 'Payment Term Canceled',
      charged_on: 'należność pobrana %{date}',
      due: 'należne %{date}',
      due_passed: 'Due date has passed',
      due_soon: 'należność zostanie pobrana w ciągu 24 godzin',
      due_with_card: 'Will be charged on %{date} with card ending in %{last4}',
      error_saving: 'There was an error saving your card',
      pay_amount: 'Pay %{amount}',
      pay_now: 'Pay Now',
      payment_number: 'Payment %{number}:',
      payment_terms: 'terminy płatności',
      please_call: 'W razie wątpliwości proszę dzwonić pod numer %{link}.',
      processing_amount: 'Processing %{amount}',
      refund: 'A refund of %{amount} was processed of on %{date}',
      select_terms: 'Select Payment Term(s) to Update'
    }
  },

  zhCN() {
    return {
      addCreditCard: '添加信用卡',
      canceled: 'Payment Term Canceled',
      charged_on: 'Charged on %{date}',
      due: '截止 %{date}',
      due_passed: 'Due date has passed',
      due_soon: '款项将在24小时内被扣除',
      due_with_card: 'Will be charged on %{date} with card ending in %{last4}',
      error_saving: 'There was an error saving your card',
      pay_amount: 'Pay %{amount}',
      pay_now: 'Pay Now',
      payment_number: 'Payment %{number}:',
      payment_terms: '付款条款',
      please_call: '如果您有任何问题，请只致电 %{link}。',
      processing_amount: 'Processing %{amount}',
      refund: 'A refund of %{amount} was processed of on %{date}',
      select_terms: 'Select Payment Term(s) to Update'
    }
  }
}
